// rsvp strings (fr).
const rsvp = {
	rsvp: {
		going: 'Je viens',
		maybe: 'Peut-être',
		cantGo: 'Je ne peux pas venir',
		respondPrompt: 'Serez-vous présent(e) ?',
		guests: 'Invités supplémentaires',
		guestsLabel: "Nombre d'invités supplémentaires",
		note: "Note pour l'hôte (facultatif)",
		notePlaceholder: 'Ajouter une note',
		save: 'Enregistrer la réponse',
		saving: 'Enregistrement...',
		thanks: 'Merci, votre réponse a été enregistrée.',
		change: 'Modifier la réponse',
		useYourLink: "Ouvrez votre lien d'invitation personnel pour répondre.",
		joinOnline: 'Rejoindre en ligne',
		addToCalendar: 'Ajouter au calendrier',
		googleCalendar: 'Google Agenda',
		appleOutlook: 'Apple / Outlook (.ics)',
		error: 'Un problème est survenu. Veuillez réessayer dans un instant.',
		invalid: 'Vérifiez votre réponse et réessayez.',
		notFound: 'Cette invitation est introuvable.',
		hostNote: "Note de l'hôte",
		decrease: 'Retirer un invité',
		increase: 'Ajouter un invité',
		yourResponse: 'Votre réponse',
		dashboard: {
			tab: 'RSVP',
			noReply: 'Sans réponse',
			plusGuests: { one: '+{{count}} invité', other: '+{{count}} invités' },
			all: 'Tous',
			filter: 'Filtrer par réponse',
			export: 'Exporter en CSV',
			name: 'Nom',
			email: 'E-mail',
			response: 'Réponse',
			guestsCol: 'Invités',
			noteCol: 'Note',
			updated: 'Mis à jour',
			empty: 'Aucun destinataire pour le moment',
			loading: 'Chargement des RSVP...',
			forbidden: "Vous n'êtes pas autorisé à voir les RSVP de cette carte.",
			error: 'Impossible de charger les RSVP. Veuillez réessayer.',
			noMatches: 'Aucun destinataire ne correspond à ce filtre',
			summary: 'Résumé des RSVP',
		},
	},
};

export default rsvp;
